export const EmptyInventorySummery = () => {
  return (
    <div>
      <h6 className="text-gray-150 text-lg"> Summary </h6>
      <div className="flex gap-4 overflow-auto justify-between border-b pb-2 border-gray-100">
        <img className="h-[10rem] w-[22rem]" src="./assets/inventoryPlaceHolders/bar-chart-place-holder.svg" />
        <img className="w-[60rem] h-[10rem]" src="./assets/inventoryPlaceHolders/chart-place-holder.svg" />
      </div>
      <h6 className="text-gray-150 pt-4 text-lg"> Materials </h6>
    </div>
  );
};
